import React from "react";
import PropTypes from "prop-types";
import { brandPropTypes, resolutionPropType } from "app/utils/propTypes";
import SimpleProgressiveImg from "app/pages/.shared/SimpleProgressiveImg";
import { BRANDS } from "app/constants";
import PopoverButton from "app/pages/.shared/Popover/PopoverButton";
import List from "app/pages/.shared/List";
import { FormattedMessage } from "react-intl";
import "./CreditCardMarketingBanner.scss";

const IMG_SIZES = {
	small: { width: 710, height: 120 },
	medium: { width: 710, height: 120 },
	large: { width: 710, height: 120 },
	xlarge: { width: 710, height: 120 },
};

const CreditCardMarketingBanner = ({ brand, shop, resolution }) => {
	return (
		brand === BRANDS.AX &&
		shop === "en-GB" && (
			<PopoverButton
				popOverClassName="credit-card-marketing-banner__button"
				popOverPosition="above"
				popOverContent={
					<div className="credit-card-marketing-banner__tooltip">
						<List
							items={[
								<FormattedMessage
									id="payment.credit.card.amex.tooltip.message.1"
									key="payment.credit.card.amex.tooltip.message.1"
								/>,
							]}
						/>
					</div>
				}
				buttonLabel={
					<SimpleProgressiveImg
						resolution={resolution}
						sizes={IMG_SIZES}
						src={`https://res.cloudinary.com/perfectstay/image/upload/credit-card-marketing/${brand}/${shop}/banner.png`}
					/>
				}
			/>
		)
	);
};

CreditCardMarketingBanner.propTypes = {
	brand: brandPropTypes,
	shop: PropTypes.string,
	resolution: resolutionPropType,
};

export default React.memo(CreditCardMarketingBanner);
